import React from "react";
import { useSelector } from "react-redux";

import { getSubscriberName } from "../../../../store/info";
import { HeaderUserMenu } from "./HeaderUserMenu";
import { useLogoutMenuItem } from "./useLogoutMenuItem";
import { useHelpLinkMenuItem } from "../../../helpPageLink/HelpPageLink";

export function WizardHeaderUserMenu() {
  const subscriberName = useSelector(getSubscriberName);
  const [logoutMenuItem, sidebarLogoutMenuItem] =
    useLogoutMenuItem(subscriberName);
  const helpPageLinkItem = useHelpLinkMenuItem();

  return (
    <HeaderUserMenu
      dropdownItems={[helpPageLinkItem, logoutMenuItem]}
      sidebarItems={[helpPageLinkItem, sidebarLogoutMenuItem]}
      subscriberName={subscriberName}
    />
  );
}
